/**
 * 默认头像
 * @param gender
 */
const getDefaultAvatar = (gender?: number) => {
  if (gender === 2) {
    return 'http://xingyu-oneadds.oss-cn-shenzhen.aliyuncs.com/file/56a6f92e-8e8d-4fda-9730-fa95738f9079.png'
  } else {
    return 'http://xingyu-oneadds.oss-cn-shenzhen.aliyuncs.com/file/6ac17ee1-fe73-4494-83ab-c82931e14aac.png'
  }
}

const queryHandle = (data: any) => {
  Object.keys(data).forEach((v) => {
    if (!data[v] || data[v] < 0) delete data[v]
  })
}

export { getDefaultAvatar, queryHandle }
